export const IMAGE_URL = [
  'https://images.unsplash.com/photo-1564359179886-afa7f541e3b8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2555&q=80',
  'https://images.unsplash.com/photo-1657915690651-c3d437261a1a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxNDk2NTV8MHwxfHJhbmRvbXx8fHx8fHx8fDE2NjAyMjY3OTY&ixlib=rb-1.2.1&q=80&w=1080&utm_source=api_app&utm_medium=referral&utm_campaign=api-credit ',
  'https://images.unsplash.com/photo-1476231682828-37e571bc172f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxNDk2NTV8MHwxfHNlYXJjaHwxMHx8Zm9yZXN0fGVufDB8fHx8MTY2MDIyNjc2Nw&ixlib=rb-1.2.1&q=80&w=1080&utm_source=api_app&utm_medium=referral&utm_campaign=api-credit',
];

export const DEFAULT_BACKGROUND = (index: number) =>
  Object.freeze({
    IMAGE_ALT: '',
    IMAGE_COVER: 'cover',
    IMAGE_URL: IMAGE_URL[index],
    IMAGE_POSITION: 'center',
    IMAGE_REPEAT: 'no-repeat',
  });

export const VERTICAL_ALIGN_MAPPER = Object.freeze({
  top: 'flex-start',
  middle: 'center',
  bottom: 'flex-end',
});
